import { Box, Chip, Grid2 } from "@mui/material";
import React from "react";
import TextCustomerBankInfo from "../common/TextCustomerBankInfo";
import TextCustomerBankInfoValue from "../common/TextCustomerBankInfoValue";

export default function CustomerBankInfo() {
  return (
    <Box
      sx={{
        padding: "24px 32px",
        backgroundColor: "#201E2C",
        borderRadius: "8px",
      }}
    >
      <Grid2 container>
        <Grid2 size={6}>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextCustomerBankInfo>Account Holder:</TextCustomerBankInfo>
            <TextCustomerBankInfo> Account Number:</TextCustomerBankInfo>
            <TextCustomerBankInfo> Bank Name:</TextCustomerBankInfo>
            <TextCustomerBankInfo> Status:</TextCustomerBankInfo>
          </Box>
        </Grid2>
        <Grid2 size={6}>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextCustomerBankInfoValue>Noni Madueke</TextCustomerBankInfoValue>
            <TextCustomerBankInfoValue>10003495230311</TextCustomerBankInfoValue>
            <TextCustomerBankInfoValue>Techcombank</TextCustomerBankInfoValue>
            <Chip
              label="Verify"
              size="small"
              sx={{
                backgroundColor: "#15141B",
                color: "#22C55E",
                width: "100px",
                borderRadius: "8px",
                padding: "4px 16px",
              }}
            />
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
}
